import { ASTNode, NameNode, visit } from "graphql";

export function isAstNode(a: any): a is ASTNode {
  return a.kind !== undefined;
}
export function hasAncestor(kind: string) {
  return (
    ancestors: ReadonlyArray<ASTNode | ReadonlyArray<ASTNode>>
  ): boolean =>
    ancestors.some(a => {
      if (isAstNode(a)) {
        return a.kind === kind;
      }
      return false;
    });
}
export const hasOperationAncestor = hasAncestor("OperationDefinition");
export const hasFragmentAncestor = hasAncestor("FragmentDefinition");
export function getName(node: { name: NameNode }): string {
  return node.name.value;
}
export function fragmentsUsed(node: ASTNode) {
  const names: string[] = [];
  visit(node, {
    FragmentSpread: f => {
      names.push(getName(f));
    }
  });
  return names;
}
